import { GetStaticProps } from 'next';
import { getPlaceholders } from '@/common/service/api/Activity/Activity';
import { getRedirectsPath } from '@/common/service/api/Redirects/getRedirectsPath';
import { RecommendsPage, TRecommendsPageProps } from '@/screens/RecommendsPage/RecommendsPage';
import { getActivitiesByIds } from '@/entities/Activity/service/getActivitiesByIds';
import { mapActivitiesToRecommends } from '@/screens/RecommendsPage/mapActivitiesToRecommends';


export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

type PageStaticProps = {
    trip_ids: string[];
};

export const getStaticProps: GetStaticProps<TRecommendsPageProps, PageStaticProps> = async ({
    params,
    // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
    try {
        if (!params) {
            throw new Error(`PAGE THINGS TO DO /DESTINATION/CATEGORY: BAD PARAMS: ${params}`);
        }

        const affiliateName = (!+params.trip_ids[0] && params.trip_ids.slice(1).every(id => !!+id))
            ? params.trip_ids[0]
            : '';

        const tripsIds = !!affiliateName ? params.trip_ids.slice(1) : params.trip_ids;

        const isValidIds = tripsIds.every(id => !!+id);

        if (!isValidIds) {
            const redirectPath = await getRedirectsPath(`/widget/recommends/${params.trip_ids.join('/')}/`);

            if (redirectPath === '/404/') {
                return {
                    notFound: true,
                };
            }

            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect: {
                    destination: redirectPath.toLowerCase(),
                    statusCode: 301,
                },
            };
        }

        const activities = await getActivitiesByIds({ids: tripsIds.join(',')});

        if (!activities.length) {
            const redirectPath = await getRedirectsPath(`/widget/recommends/${params.trip_ids.join('/')}/`);

            if (redirectPath === '/404/') {
                return {
                    notFound: true,
                };
            }

            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect: {
                    destination: redirectPath.toLowerCase(),
                    statusCode: 301,
                },
            };
        }

        const ids = activities.map(({ id }) => id);

        const [placeholders] = await Promise.all([
            getPlaceholders(ids, 'activity'),
        ]);

        const recommends = mapActivitiesToRecommends(activities, affiliateName);

        return {
            revalidate: Number(process.env.CACHE_ENV),
            props: {
                recommendedTrips: recommends,
                placeholders,
            },
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default RecommendsPage;
